import { useEffect, useState } from "react";
import Link from "../../components/Link"
import { Checkout } from "../../components/checkout"
import { ArrowLeft } from "lucide-react"
// import Link from "next/link"


const payInfo = [
  {    name: "The Shift Of Thrones - Pre-Release",
    description: "Your book will be personally signed and shipped to you upon publication.",
    price: "$10.99",
    shipping: "$3.99",
    total: "$14.98",
    productId: "price_1SUpi1CUIPnkZWl7DXC6MdUL",
  },  
  {    name: "Lord Build Me A House - Standard",
    description: "",
    price: "$10.99",
    shipping: "$4.00",
    total: "$14.99",
    // productId: "price_1SUpkwCUIPnkZWl7ci7groNf",
    productId: "price_1SVumUCUIPnkZWl7UZEK0KUM",
  },
]

export default function CheckoutPage() {
  const [PayId, setPayId] = useState<any>(null);
  const [payDetails, setPayDetails] = useState<any>([]);

  useEffect(() => {
    // Check if there's a book ID in query params
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get("id");
    
    if (id) {
      setPayId(id);
      if (id === "pre-release") {
        setPayDetails(payInfo[0]);
      } else if (id === "standard") {
        setPayDetails(payInfo[1]);
      }
    }
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-br from-gray-50 to-white mt-20">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-red-700 font-medium hover:text-red-800 transition-colors duration-300 mb-8"
        >
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Complete Your Order</h1>
            <p className="text-gray-600">Purchase your personally signed {PayId} copy of "{payDetails.name}"</p>
          </div>

          <div className="mb-8 p-6 bg-amber-50 border border-amber-200 rounded-lg">
            <h2 className="font-semibold text-gray-900 mb-2">{payDetails.name}</h2>
            <p className="text-gray-700 mb-4">
              {payDetails.description || "Standard edition, not signed."}
            </p>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Price:</span>
              <span className="font-bold text-gray-700">{payDetails.price}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Shipping:</span>
              <span className="font-bold text-gray-700">{payDetails.shipping}</span>
            </div>
            <div className="flex justify-between items-center mt-5">
              <span className="text-gray-600">Total:</span>
              <span className="text-2xl font-bold text-green-700">{payDetails.total}</span>
            </div>
          </div>

          {payDetails.productId && <Checkout productId={payDetails.productId} />}
        </div>
      </div>
    </main>
  )
}
